import { forwardRef } from 'react';

import { SearchIcon } from 'components/Blocks/Icons';
import { Input, InputProps } from 'components/Blocks/Inputs';

type Props = Pick<InputProps, 'value' | 'onChange'>;

export const SearchInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  return (
    <div className="relative">
      <SearchIcon size={14} className="absolute left-2 top-1/2 -translate-y-1/2" />

      <Input
        ref={ref}
        focusStyle="border"
        size="small"
        className="h-auto py-1 pl-7 pr-2"
        {...props}
      />
    </div>
  );
});

SearchInput.displayName = 'SearchInput';
